import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Buttons'
import { useTheme } from '@material-ui/core'

interface ConfirmDialogProps {
  open: boolean
  id: string
  onConfirm: () => void
  onCancel: () => void
  title?: React.ReactNode
}

const ConfirmDialog = ({
  open,
  id,
  onConfirm,
  onCancel,
  title,
}: ConfirmDialogProps) => {
  const theme = useTheme()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        style: {
          borderRadius: 8,
          minWidth: 500,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <DialogTitle disableTypography style={{ padding: '24px 28px 0' }}>
        <Typography style={{ fontFamily: '"Public Sans", sans-serif', fontSize: 17, fontWeight: 600, color: theme.palette.text.primary }}>
          {title ?? <FormattedMessage id="confirmDialog.title" defaultMessage="Unsaved Changes" />}
        </Typography>
      </DialogTitle>

      <DialogContent style={{ padding: '20px 28px 8px' }}>
        <Divider style={{ marginBottom: 20, background: theme.palette.divider }} />
        <Box style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <WarningRoundedIcon style={{ color: '#F59E0B', fontSize: 34, flexShrink: 0 }} />
          <Typography style={{ fontFamily: '"Public Sans", sans-serif', fontSize: 14, color: theme.palette.text.secondary, lineHeight: 1.7 }}>
            <FormattedMessage id={id} defaultMessage="Are you sure you want to close and lose your changes?" />
          </Typography>
        </Box>
        <Divider style={{ marginTop: 20, background: theme.palette.divider }} />
      </DialogContent>

      <DialogActions style={{ padding: '14px 24px 20px', gap: 10 }}>
        <Button.NoButton click={onCancel} />
        <Button.YesButton click={onConfirm} />
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog